var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOutlook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0264 6.78467V13.044L22.238 14.4214C22.2963 14.4382 22.4227 14.4394 22.481 14.4214L31.9993 8.07428C31.9993 7.32311 31.2909 6.78467 30.8911 6.78467H20.0264Z",
    fill: "#0072C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0256 15.3793L22.044 16.7507C22.3284 16.9574 22.671 16.7507 22.671 16.7507C22.3296 16.9574 31.9998 10.6042 31.9998 10.6042V22.1086C31.9998 23.361 31.1893 23.8862 30.2779 23.8862H20.0244V15.3793H20.0256Z",
    fill: "#0072C6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5752 12.4934C8.88741 12.4934 8.33938 12.8131 7.93473 13.4513C7.53008 14.0895 7.32715 14.9344 7.32715 15.9861C7.32715 17.0533 7.53008 17.897 7.93473 18.5172C8.33938 19.1386 8.8704 19.4475 9.52659 19.4475C10.2034 19.4475 10.7405 19.1458 11.1367 18.5425C11.5328 17.9391 11.7321 17.1014 11.7321 16.0305C11.7321 14.914 11.5401 14.045 11.1549 13.4237C10.7697 12.8035 10.2435 12.4934 9.5752 12.4934Z",
    fill: "#0072C6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.60563V28.0939L18.835 32V0L0 3.60563ZM12.6036 19.9896C11.8077 21.0257 10.77 21.5449 9.48919 21.5449C8.24122 21.5449 7.22534 21.0425 6.43913 20.0389C5.65414 19.0341 5.26043 17.7265 5.26043 16.1136C5.26043 14.4105 5.659 13.0332 6.45736 11.9815C7.25572 10.9299 8.31291 10.4035 9.62893 10.4035C10.872 10.4035 11.8782 10.9058 12.645 11.913C13.4129 12.9202 13.7969 14.2471 13.7969 15.8948C13.7981 17.5883 13.3996 18.9536 12.6036 19.9896Z",
    fill: "#0072C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOutlook);
export default __webpack_public_path__ + "static/media/icon-outlook.6e784169cc69cb86e59bea72dc34ef61.svg";
export { ForwardRef as ReactComponent };